<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >
                    
                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        

                    <!-- Row -->
                    <div class="row">
                       
                        <div class="col-lg-12 col-xs-12 col-xl-6">
                            <p class="page-text margin-bottom-20 margin-top-0">
                                Visualize abaixo os resultados dos seus exames.
                            </p>                           
                        </div>
                        <div class="col-xl-12">
                            <div class="dashboard-box margin-top-0 cards exames">
                                <div class="content" v-if="data">

                                    <form method="get" style="width: 100%;" novalidate="" class="margin-bottom-0" v-on:submit.prevent="get">
                                        <div class="row">
                                            <div class="col-lg-3 col-xs-6 col-xl-2 col-md-5">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5>De:</h5>
                                                    <input type="date" data-placeholder="___ /____ /_____" required="" class="with-border margin-bottom-0" v-model="form.dataInicio">
                                                </div>
                                            </div>        
                                            <div class="col-lg-3 col-xs-6 col-xl-2 col-md-5">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5>Até:</h5>
                                                    <input type="date" data-placeholder="___ /____ /_____" required="" class="with-border margin-bottom-0" v-model="form.dataFinal">
                                                </div>
                                            </div>    
                                            <div class="col-lg-2 col-xs-6 col-xl-2 col-md-2" style="padding-right: 0px;">
                                                <div class="submit-field" v-if="data.grupos">
                                                    <h5>Grupo:</h5>
                                                    <select class="with-border" v-model="form.grupo">
                                                        <option value="">Todos</option>
                                                        <option v-for="(item, index) in data.grupos" :key="item.cod" :value="item">{{item}}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-lg-3 col-md-2 col-xs-4 hidden-xs hidden-md" style="">
                                                <div class="submit-field">
                                                    <div class="clearfix" style="margin-top: 21px;"></div>
                                                    <button type="submit" class="button green small" style="height: 40px">
                                                        <i class="las la-search"></i>
                                                        Filtrar
                                                    </button>                                          
                                                </div>
                                            </div>                                    

                                            <div class="col-lg-3 col-md-4 col-xs-5 hidden-lg hidden-xl" style="text-align: right;">
                                                <div class="submit-field">
                                                    <div class="hidden-xl hidden-lg hidden-sm hidden-md" style="margin-top: 22px;"></div>
                                                    <div class="hidden-xs clearfix hidden-xl hidden-md" style="margin-top: 32px;"></div>
                                                    <button type="submit" class="button green small block-mobile" style="height: 40px">
                                                        <i class="las la-search"></i>
                                                        Filtrar
                                                    </button>                                          
                                                </div>
                                            </div>
                                        </div>
                                        <div class="hidden-sm hidden-xl margin-top-20"></div>
                                    </form> 

                                    <div class="row">
                                        <div class="col-xs-12 col-xl-12">
                                            <h5 class="block-title ">
                                                <i class="las la-list"></i>
                                                Lista de requisição de exames</b>
                                                <small v-if="data.CLINIC_PEDIDO_EXAME.length > 0" style="display: block; font-size: 12px; margin-top: 0px; margin-bottom: 15px; color: #555; line-height: 130%;">Toque na requisição abaixo para visualizar todos os exames.</small>
                                            </h5>

                                            <h5 v-if="data.CLINIC_PEDIDO_EXAME.length == 0" class="empty">
                                                <i class="las la-times"></i>                                          
                                                Nenhum resultado encontrado.
                                            </h5>
                                            <!-- <ul class="dashboard-box-list lg-scroll" v-if="data.CLINIC_PEDIDO_EXAME.length > 0"> -->
                                            <ul class="dashboard-box-list lg-scroll" v-if="data.CLINIC_PEDIDO_EXAME.length > 0">
                                                <li v-for="(item, index) in data.CLINIC_PEDIDO_EXAME" class="click" style="padding: 0px; " v-bind:class="{'disabled': item.selecionado}">
                                                    <a class="job-listing card2">
                                                        <div class="job-listing-details" style="padding-top: 0px !important" v-on:click="openPrescricao(item)">
                                                            <div class="job-listing-description" style="padding-top: 12px;">
                                                                <div class="row">
                                                                    <div class="col-lg-12 col-xl-12 col-xs-12">

                                                                        <span class="dashboard-status-button color-primary margin-top-5 margin-bottom-5" style="font-weight: bold" v-if="item.GRUPO">{{item.GRUPO}}</span>
                                                                        <span class="block margin-top-5 margin-bottom-5">
                                                                            {{item.DS_EXAMES}}
                                                                        </span>
                                                                        <span class="block" style="color: #999">
                                                                            <i class="las la-user"></i> Médico solicitante: <b style="color: #666; font-weight: 600">{{item.NM_MEDICO}}</b>
                                                                        </span> 
                                                                        <span class="block" style="color: #999">
                                                                            <i class="las la-file"></i> Prescrição: <b style="color: #666; font-weight: 600">{{item.NR_PRESCRICAO}}</b>
                                                                        </span>                                                                         
                                                                        <span class="block" style="color: #999">
                                                                            <i class="las la-clock"></i> Data/hora: <b style="color: #666; font-weight: 600">{{item.DT_PRESCRICAO | formatDateTime}}</b>
                                                                        </span>                                                    
                                                                    </div>
                                                                    <div class="col-lg-12 col-xl-4 col-xs-12">

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>     
                                        <div class="col-xs-12 col-xl-6 scroll-to" style="padding-left: 20px;" v-if="data.prescricao">
                                            <h5 class="block-title ">
                                                <i class="las la-list-alt"></i>
                                                Lista de exames <b>{{data.prescricao.CLINIC_EXAMES_PEDIDO.length > 0 ? "(" + data.prescricao.CLINIC_EXAMES_PEDIDO.length + ")" : ''}}</b>
                                                
                                                <small v-if="data.prescricao.CLINIC_EXAMES_PEDIDO.length > 0" style="display: block; font-size: 12px; margin-top: 0px; margin-bottom: 15px; color: #555; line-height: 130%;">Toque no exame desejado para visualizar mais detalhes.</small>
                                            </h5>

                                            <div class="row margin-bottom-15" v-if="data.prescricao.CLINIC_EXAMES_PEDIDO.length > 0">
                                                <div class="col-xs-12">
                                                    <button type="button" v-on:click="selecionarTodosExames()" class="button gray small" style="font-size: 12px">
                                                        <i v-if="!selecionarTodosExamesAtivo" class="las la-check-square"></i>
                                                        <i v-if="selecionarTodosExamesAtivo" class="las la-minus-square"></i>
                                                        Selecionar todos
                                                    </button>
                                                    <button type="button" v-on:click="exportarExames()" class="button gray small" style="font-size: 12px">
                                                        <i class="las la-download"></i>
                                                        Salvar selecionados
                                                    </button>                                            
                                                </div>
                                            </div>

                                            <h5 v-if="data.prescricao.CLINIC_EXAMES_PEDIDO.length == 0" class="empty">
                                                <i class="las la-times"></i>                                          
                                                Nenhum resultado encontrado.
                                            </h5>
                                            <!-- <ul class="dashboard-box-list lg-scroll" v-if="data.prescricao.CLINIC_EXAMES_PEDIDO.length > 0"> -->
                                            <ul class="dashboard-box-list" v-if="data.prescricao.CLINIC_EXAMES_PEDIDO.length > 0">
                                                <li v-for="(item, index) in data.prescricao.CLINIC_EXAMES_PEDIDO" style="padding: 0px;" class="click">
                                                    <a class="job-listing card2">
                                                        <div class="checkbox margin-top-15">
                                                            <input type="checkbox" :id="'item-exame-' + item.NR_SEQ_INTERNO" true-value="true" false-value="false" v-model="item.selecionado" >
                                                            <label :for="'item-exame-' + item.NR_SEQ_INTERNO" class="margin-bottom-0" style="padding-left: 26px; "><span class="checkbox-icon"></span> 
                                                                #{{item.NR_SEQ_INTERNO}}
                                                        
                                                                <span class="dashboard-status-button color-primary margin-top-0 float-right" style="font-size: 12px" v-if="item.GRUPO">{{item.GRUPO}}</span>

                                                            </label>
                                                        </div>
                                                        <div class="job-listing-details" style="padding-top: 0px !important" v-on:click="openExame(item)">
                                                            <div class="job-listing-description" style="padding-top: 0px;">
                                                                <div class="row">
                                                                    <div class="col-lg-12">


                                                                        <span class="dashboard-status-button color-white margin-top-5">{{item.NM_EXAME}}</span>
                                                                        <br>
                                                                        <span style="font-size: 12px; color: #555;">
                                                                            <!-- <i class="las la-clock"></i> Data/hora: <b style="color: #666">{{item.DT_PRESCRICAO | formatDateTime}}</b> -->


                                                                            <span v-if="item.DS_LIBERADO != 'Liberado'" class="dashboard-status-button color-orange" style="padding: 2px 6px; line-height: 16px; margin-top: 5px;  font-size: 14px; font-weight: bold; display: block; text-align: center; ;">
                                                                                {{item.DS_LIBERADO}}
                                                                            </span>

                                                                            <span v-if="item.DS_LIBERADO == 'Liberado'" v-on:click.stop.prevent="exportarExame(item)" class="dashboard-status-button color-green block-mobile" style="padding: 2px 6px; line-height: 16px; margin-top: 5px;  font-size: 14px; font-weight: bold; display: block; text-align: center; ">
                                                                                <i class="las la-download"></i>
                                                                                Laudo
                                                                            </span>                                                       
                                                                        </span>                                                 
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>                                     
                                        <div class="col-xs-12 col-xl-6" style="padding-left: 20px; min-height: 100vh;" v-if="data.prescricao">
                                           
                                            <h5 class="block-title ">
                                                <i class="las la-file-alt"></i>
                                                Visualização
                                                <span v-if="data.prescricao.CLINIC_EXAMES_PEDIDO[0]">
                                                    <button type="button" v-if="data.prescricao.CLINIC_EXAMES_PEDIDO[0].DS_END_PACS" v-on:click.stop.prevent="visualizarPacs(data.prescricao.CLINIC_EXAMES_PEDIDO[0])" class="button color-orange small float-right" style="">
                                                        <i style="color: #fff; top: 0px;" class="las la-eye"></i>
                                                        Imagens do exame
                                                    </button>            
                                                </span>
                                            </h5>

                                            <small v-if="data.prescricao.CLINIC_EXAMES_PEDIDO.length > 0" style="display: block; font-size: 12px; margin-top: 0px; margin-bottom: 15px; color: #555; line-height: 130%;">Consulte abaixo a visualização completa da requisição de exames.</small>
                                            <div class="loading-preview-prescricao">                                                
                                                <div class="loadingio-spinner-rolling-afwndezwb5v">
                                                    <div class="ldio-cxcz2rj5xqh">
                                                        <div></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <iframe class="preview-prescricao" style="width: 100%; height: 100vh; border: none; display: none;"></iframe>
                                        </div>                                                                                
                                    </div>
                                </div>
                            </div> 
                        </div>                         
                    </div>

                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Exames',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];
            return date;

        },
        formatDateTime: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        }, 
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            "selecionarTodosExamesAtivo": false,
            "loaded":               false,
            "data":                 {
                "CLINIC_PEDIDO_EXAME":   [],
                "prescricao":       null,
            },
            "loading": {
                "submit":           false
            },           
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "grupo":            ""
            },
        }
    },
    watch: {
                  
    },
    methods: {     
        getPreviewPrescricao: function(item) {
            var self = this;
            console.log("getPreviewPrescricao()", item);
            return new Promise(function(resolve, reject) {

                $(".loading-preview-prescricao").show();
                $(".preview-prescricao").hide();

                self.urlPreviewPrescricao = "";
                
                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "NR_PRESCRICAO": item.NR_PRESCRICAO,
                        "GRUPO":        item.GRUPO,
                        "tipo":         "preview"
                    }
                };

                axios.get("api/exames.php", form)
                .then(response => {
                    
                    console.log("getPreviewPrescricao() response", response);

                    if (response.data.link) {
                        var urlPdf = self.$root.config.url + '/viewer/web/viewer-geral.php?_cod=' + self.$root.user.cod + '&_token=' + self.$root.user.token + '&doc=' + response.data.link;
                        self.urlPreviewPrescricao = urlPdf;

                        $(".preview-prescricao").attr("src", urlPdf);
                        
                        setTimeout(function() {
                            $(".loading-preview-prescricao").hide();
                            $(".preview-prescricao").show();
                        }, 1000);
                        console.log("Setou link", response.data.link)
                    } else {
                        $(".loading-preview-prescricao").hide();    
                    }

                    resolve(response.data);
                  
                })
                .catch(error => {
                    console.log("getPreviewPrescricao() error", error);                    
                    loading.hide();
                    $(".loading-preview-prescricao").hide();    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },
        exportarExame: function(item) {
            var self        = this;
            console.log("exportarExame()", item);
            loading.show();

            self.$root.addLog({
                "acao":             "EXPORTAR_EXAME_PACIENTE", 
                "pessoaFisicaNome": self.$root.user.nome,
                "pessoaFisicaCod":  self.$root.user.codigoIntegracao,
                "descricao":        item.GRUPO + " - " + item.NM_EXAME,
                "referenciaCod":    item.NR_SEQ_INTERNO
            });

            return new Promise(function(resolve, reject) {

                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "acao":         "exportar",
                    "NR_SEQ_INTERNO":item.NR_SEQ_INTERNO,
                    "NM_EXAME":     item.NM_EXAME,
                    "GRUPO":        item.GRUPO,
                    "DT_PRESCRICAO":item.DT_PRESCRICAO,
                    "DS_RESULTADO": item.DS_RESULTADO,
                };
                    
                axios.put("api/exames.php", form)
                .then(response => {

                    console.log("exportarExame()", "success", response.data.link)
                    loading.hide();
                    window.open(response.data.link, "_system");
                    // alert(response.data.message);

                })
                .catch(error => {

                    console.log("exportarExame()", "error", error.data)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

                });
               
               
            });   
        },           
        openPrescricao: function(item) {
            var self = this;
            console.log("openPrescricao()", item);
            return new Promise(function(resolve, reject) {

                self.data.CLINIC_PEDIDO_EXAME.forEach(function(item, index) {
                    if (item.selecionado) self.data.CLINIC_PEDIDO_EXAME[index]["selecionado"] = false;
                });

                self.selecionarTodosExamesAtivo     = false;
                item.selecionado                    = true;
                self.$forceUpdate();

                self.getPreviewPrescricao(item);

                loading.show();
                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "NR_PRESCRICAO": item.NR_PRESCRICAO,
                        "GRUPO":        item.GRUPO,
                    }
                };

                axios.get("api/exames.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data.prescricao = response.data.result;
                    self.$forceUpdate();

                    resolve(response.data.result);

                    if (response.data.result.CLINIC_EXAMES_PEDIDO.length > 0) {

                        $(".dashboard-content-inner")[0].scrollTo({
                            top:            0
                        });                        
                        setTimeout(function() {
                            $(".dashboard-content-inner")[0].scrollTo({
                                top:            $(".scroll-to")[0].getBoundingClientRect().top - (window.__app.mobile.isMobile ? 70 : 0),
                                behavior:       "instant"
                            });             
                            setTimeout(function() {
                                loading.hide();
                            }, 500);                    
                        }, 100);                    
                    } else {
                        loading.hide();
                        alert("🚫 Nenhum exame encontrado dentro desta requisição.");
                    }

                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },        
        visualizarPacs: function(item) {
            var self        = this;
            console.log("visualizarPacs()", item);

            self.$root.addLog({
                "acao":             "VISUALIZAR_PACS_PACIENTE", 
                "pessoaFisicaNome": self.$root.user.nome,
                "pessoaFisicaCod":  self.$root.user.codigoIntegracao,
                "descricao":        item.GRUPO + " - " + item.NM_EXAME,
                "referenciaCod":    item.NR_SEQ_INTERNO
            });

            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "acao":         "visualizar-pacs",
                    "NR_SEQ_INTERNO":item.NR_SEQ_INTERNO
                };
                    
                axios.put("api/exames.php", form)
                .then(response => {

                    console.log("visualizarPacs()", "success", response.data.link)
                    loading.hide();
                    window.open(response.data.link, "_system");
                    // alert(response.data.message);

                })
                .catch(error => {

                    console.log("visualizarPacs()", "error", error.data)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

                });
               
               
            });   
        },            
        openExame: function(item) {
            var self = this;
            console.log("openExame()", item);
            loading.show();

            self.$root.addLog({
                "acao":             "VISUALIZAR_EXAME_PACIENTE", 
                "pessoaFisicaNome": self.$root.user.nome,
                "pessoaFisicaCod":  self.$root.user.codigoIntegracao,
                "descricao":        item.GRUPO + " - " + item.NM_EXAME,
                "referenciaCod":    item.NR_SEQ_INTERNO
            });

            var form = {
                "_cod":         self.$root.user.cod, 
                "_token":       self.$root.user.token,
                "acao":         "exportar",
                "NR_SEQ_INTERNO":item.NR_SEQ_INTERNO,
                "NM_EXAME":     item.NM_EXAME,
                "GRUPO":        item.GRUPO,
                "DT_PRESCRICAO":item.DT_PRESCRICAO,
                "DS_RESULTADO": item.DS_RESULTADO,
            };
                
            axios.put("api/exames.php", form)
            .then(response => {

                console.log("openExame()", "success", response.data.link)

                var urlPdf = self.$root.config.url + '/viewer/web/viewer-geral.php?_cod=' + self.$root.user.cod + '&_token=' + self.$root.user.token + '&doc=' + response.data.link;
                
                if (window.cordova) {
                    window.open(urlPdf, "_blank", "location=yes,hideurlbar=yes,hidenavigationbuttons=yes");
                } else {
                    self.$root.openModal("modalExame", "<iframe src='" + urlPdf + "' style='width: 100%; height: 100%; border: none; margin-bottom: -8px'></iframe>"); 
                }
                
                setTimeout(function() {
                    loading.hide();
                }, 1000);
                // alert(response.data.message);

            })
            .catch(error => {

                console.log("exportarExame()", "error", error.data)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

            });
        },
        selecionarTodosExames: function() {
            var self    = this;
            
            self.selecionarTodosExamesAtivo = (self.selecionarTodosExamesAtivo ? false : true);
            console.log("selecionarTodosExames()");
            self.data.prescricao.CLINIC_EXAMES_PEDIDO.forEach(function(item) {
                console.log(">", item);
                item.selecionado = self.selecionarTodosExamesAtivo;
            });
            self.$forceUpdate();
        },        
        exportarExames: function() {
            var self        = this;
            console.log("exportarExames()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var itens           = [];
                self.data.prescricao.CLINIC_EXAMES_PEDIDO.forEach(function(item) {
                    if (item.selecionado) {
                        itens.push(item.NR_SEQ_INTERNO);
                    }
                });

                if (itens.length == 0) {
                    loading.hide();
                    reject("Nenhum exame selecionado");
                    return false;
                }

                if (itens.length >= 10) {
                    loading.hide();
                    alert("Por favor, aguarde enquanto os exames estão sendo processados, pode demorar alguns segundos.")
                }

                self.data.prescricao.CLINIC_EXAMES_PEDIDO.forEach(function(item) {
                    if (item.selecionado) {
                        self.$root.addLog({
                            "acao":             "EXPORTAR_EXAME_PACIENTE", 
                            "pessoaFisicaNome": self.$root.user.nome,
                            "pessoaFisicaCod":  self.$root.user.codigoIntegracao,
                            "descricao":        item.GRUPO + " - " + item.NM_EXAME,
                            "referenciaCod":    item.NR_SEQ_INTERNO
                        });
                    }
                });

                console.log("Itens selecionados:", itens);

                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "acao":         "exportar-multiplos",
                    "NR_SEQ_INTERNO":itens,
                };
                    
                axios.put("api/exames.php", form, {"timeout": 300000})
                .then(response => {

                    console.log("exportarExames()", "success", response.data)
                    loading.hide();
                    if (response.data.link) {
                        window.open(response.data.link, "_system");
                    }
                    resolve(response);
                    // alert(response.data.message);

                })
                .catch(error => {

                    reject(error);
                    console.log("exportarExames()", "error", error.data)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

                });
               
               
            });   
        },                      
        exportar: function(item) {
            var self        = this;
            console.log("exportar()", item);
            loading.show();

            self.$root.addLog({
                "acao":             "EXPORTAR_EXAME_PACIENTE", 
                "pessoaFisicaNome": self.$root.user.nome,
                "pessoaFisicaCod":  self.$root.user.codigoIntegracao,
                "descricao":        item.GRUPO + " - " + item.NM_EXAME,
                "referenciaCod":    item.NR_SEQ_INTERNO
            });

            return new Promise(function(resolve, reject) {

                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "acao":         "exportar",
                    "NR_SEQ_INTERNO":item.NR_SEQ_INTERNO,
                    "NM_EXAME":     item.NM_EXAME,
                    "GRUPO":        item.GRUPO,
                    "DT_PRESCRICAO":item.DT_PRESCRICAO,
                    "DS_RESULTADO": item.DS_RESULTADO,
                };
                    
                axios.put("api/exames.php", form)
                .then(response => {

                    console.log("exportar()", "success", response.data.link)
                    loading.hide();
                    window.open(response.data.link, "_system");
                    // alert(response.data.message);

                })
                .catch(error => {

                    console.log("exportar()", "error", error.data)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

                });
               
               
            });   
        },
        get: function(load) {
            var self        = this;
            console.log("get()");
            if (load) loading.show();
            return new Promise(function(resolve, reject) {
                axios.get("api/exames.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data           = JSON.parse(JSON.stringify(response.data.result));
                    self.$forceUpdate();
                    if (load) loading.hide();

                    console.log(">", self.data)
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    if (load) loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        }        
    },
    created: function() {
        var self = this;

        loading.show();

        if (self.$route.query.CD_PESSOA_FISICA) {
            self.form.CD_PESSOA_FISICA = self.$route.query.CD_PESSOA_FISICA;
        }

        self.$root.addLog({
            "acao":             "VISUALIZAR_EXAMES",
            "pessoaFisicaNome": self.$root.user.nome,
            "pessoaFisicaCod":  self.$root.user.codigoIntegracao,            
            "referenciaCod":    ""
        });        

        Promise.all([
            self.get()
        ]).then(function() {
        
            setTimeout(function() {
                loading.hide();
            }, 500);
            
        }).catch(function(error) {
            loading.hide();
        });         

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .table td button i {
        font-size: 20px !important;
        color: #fff;
    }
    .table td button {
        margin-top: 0px !important;
    }
    .table td {
        /*border-right: none;*/
        /*border-left: none;*/
    }
    .table td input, .table td select {
        margin-top: 0px;
        margin-bottom: 0px;
        text-align: left
    }
    .read-only {
        pointer-events: none !important;
        -webkit-touch-callout: none;                /* prevent callout to copy image, etc when tap to hold */
        -webkit-text-size-adjust: none;             /* prevent webkit from resizing text to fit */
        -webkit-user-select: none;             
    }
    .attachment-box {
        border: none !important;
        padding-bottom: 15px;
/*        display: block !important;
        position: relative;*/
    }
    div.float-right {
        float: right;
        display: inline-block;
    }
    .buttons {
        /*position: absolute;*/
        /*top: 10px;*/
        /*right: 25px; */
        margin-top: 10px;       
    }
    .attachment-box small div {
        font-size: 12px;
    }
    .attachment-box small {
        color: #888;
        display: block;
        font-weight: 300;
    }
    .attachment-box span {
        font-size: 16px !important;
        margin-bottom: 5px;
    }
    .dashboard-status-button {
     
        margin-right: 5px;
        line-height: 32px;
    }
    .dashboard-status-button i {
        color: #fff;
        top: 0px;
        display: inline-block !important;
    }

    .tabs-header a {
        font-size: 16px;
        font-weight: 300;
        color: #fff;
    }

    .tabs-default ul {
        background: var(--theme-color-primary);
    }

    .tabs-default .active a {
        /*font-weight: bold;*/
    }

    .tabs-default .active {
        background: rgba(255,255,255,0.2) !important;
    }

    .button.outline {
        box-shadow: none !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Exames.vue